import { useColorModeValue } from '@chakra-ui/react';

/** Shared shell styling for fixed/sticky site navigation bars. */
export function useSiteNavBarStyles() {
  return {
    bg: useColorModeValue('white', 'bgBlue'),
    borderBottom: '1px solid',
    borderColor: useColorModeValue('blackAlpha.120', 'whiteAlpha.200'),
    /** Bottom edge only — a soft outer blur was leaving a faint vertical seam beside the logo. */
    boxShadow: useColorModeValue('none', '0 1px 4px rgba(0, 0, 0, 0.35)'),
    borderLeft: 'none',
  };
}
